import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ContentBox } from '../../components/ContentBox';
import { StackWithDivider } from '../components/StackWithDivider';
import { ApplicationNameSection } from './ApplicationNameSection';
import { LogoUploadSection } from './LogoUploadSection';
import { CropImageModal } from './CropImageModal';
import { Switch as LabeledSwitch } from '../../components/Switch';
import type { BrandSettingsPageProps } from './types';
import { SubSectionHeading } from '../../shared/Typography';

export const BrandSettingsPage = ({
  localEnabled,
  setLocalEnabled,
  isEditingName,
  setIsEditingName,
  editedName,
  setEditedName,
  setLogoFile,
  logoPreview,
  setLogoPreview,
  prevLogoFile,
  prevLogoPreview,
  isCropImageOpen,
  setIsCropImageOpen,
  handleRemoveLogo,
  handleCropSave,
  getBrandDisplayName,
  branding,
  COLORS,
  getLogoDropzoneRootProps,
  getLogoDropzoneInputProps,
  getAddLogoButtonRootProps,
  getAddLogoButtonInputProps,
  logoRemoved,
}: BrandSettingsPageProps) => {
  return (
    <ContentBox>
      <StackWithDivider>
        <SubSectionHeading px="6" py="4">
          <Flex align="center" justify="space-between">
            Branding
            <LabeledSwitch
              id="branding-toggle"
              enabled={localEnabled}
              onChange={setLocalEnabled}
              labels={{ enabled: 'On', disabled: 'Off' }}
            />
          </Flex>
        </SubSectionHeading>

        <ApplicationNameSection
          localEnabled={localEnabled}
          getBrandDisplayName={getBrandDisplayName}
          isEditingName={isEditingName}
          setIsEditingName={setIsEditingName}
          editedName={editedName}
          setEditedName={setEditedName}
          COLORS={COLORS}
        />
        <LogoUploadSection
          logoPreview={logoPreview}
          branding={branding}
          getBrandDisplayName={getBrandDisplayName}
          getLogoDropzoneRootProps={getLogoDropzoneRootProps}
          getLogoDropzoneInputProps={getLogoDropzoneInputProps}
          getAddLogoButtonRootProps={getAddLogoButtonRootProps}
          getAddLogoButtonInputProps={getAddLogoButtonInputProps}
          handleRemoveLogo={handleRemoveLogo}
          COLORS={COLORS}
          logoRemoved={logoRemoved}
        />
        {isCropImageOpen && (
          <CropImageModal
            isOpen={isCropImageOpen}
            onClose={() => {
              setLogoFile(prevLogoFile);
              setLogoPreview(prevLogoPreview);
              setIsCropImageOpen(false);
            }}
            onSave={handleCropSave}
            base64Image={logoPreview || ''}
          />
        )}
      </StackWithDivider>
    </ContentBox>
  );
};
